import jwtDecode from 'jwt-decode';

export function pushUserDataLayer() {
	const token = localStorage.getItem( 'af-token' );
	if ( !token ) return;

	try {
		const jwt = jwtDecode( token );

		window.dataLayer = window.dataLayer || [];

		window.dataLayer.push( {
			user_id    : String( jwt.userId || '' ),
			user_email : jwt.user_email || '',
			user_name  : jwt.group_name || '',
			profile    : jwt.idProfileType || '',
			client_id  : String( jwt.tenant_id || '' ),
		} );
	} catch ( _ ) {
		// silently fail — never block login flow
	}
}
